"use client"
import {Swiper, SwiperSlide} from 'swiper/react';
import {Skeleton} from '@mui/material';
import {Row} from "@/core/general/row.component";
import {VideoGardiModel} from "@/core/model/tmk.model";
import VideoGardiHorizontalComponent from "@/core/widget/component/videogardiHorizontal.component";
import {FreeMode} from "swiper/modules";
import {WidgetTitleBar} from "@/core/widget/component/widgetTitleBar";
import {MenuBuilderWidgetModel} from "@/core/model/main.model";
import {Column} from "@/core/general/column.component";
import {WidgetVideoTitleBar} from "@/core/widget/component/widgetVideoTitleBar";

interface Props {
    showMoreUrl: string
    videoList: VideoGardiModel[]
    widget: MenuBuilderWidgetModel;
    hasTitle: boolean;
}

export function VideoGardiSwiperComponent(props: Props) {

    return (
        <Column className={""}>
            <WidgetVideoTitleBar widget={props.widget} hasTitle={props.hasTitle} showMoreUrl={props.showMoreUrl}/>
            {props.videoList?.length > 0 ? (
                <Row className="flex-nowrap overflow-scroll hideScrollBar">
                    <Swiper slidesPerView={'auto'} freeMode={true} className={"!px-4"} modules={[FreeMode]}>
                        {props.videoList?.map((item, index) => (
                            <SwiperSlide style={{width: 'auto'}} key={index} virtualIndex={index}>
                                <div className="w-auto p-1" key={index}>
                                    <VideoGardiHorizontalComponent
                                        index={index}
                                        video={item}
                                        widgetTitle={""}
                                    />
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </Row>
            ) : (
                <Row className="flex-nowrap overflow-scroll hideScrollBar">
                    {[...Array(5)].map((i, index) => (
                        <div key={index} className="w-auto p-2">
                            <Skeleton className="card card-box rounded-1 shortVideoIconImage" variant="rectangular"/>
                        </div>
                    ))}
                </Row>
            )}
        </Column>
    );
};
